module.exports = __webpack_public_path__ + "img/sp_foot_ico04_active.e67fa7ed.svg";